import mapFunction from './mapResources';

export default mapFunction('cars_history', {
    isFetching: false,
    items: [] 
});
